export const ethAddress = '0xeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee' as const

export const zeroAddress = '0x0000000000000000000000000000000000000000' as const
